export enum ETipoRelacaoCadastro {
    Pessoa = 1,
}
